<template>
  <v-dialog v-model="dialogOpen" width="850" persistent class="edit-line">
    <v-card>

      <v-card-title>Line</v-card-title>

      <v-card-text>
        <div class="d-flex flex-column flex-md-row justify-md-space-between align-md-start">

          <div class="mr-md-4 edit-line__column">
            <v-row>
              <v-col>
                <v-text-field v-model="form_data.line_number" label="Line number" :disabled="getCurrentProduct.confirmed_date!==null || (getTelcoProvisioning.new_line && !getCurrentProduct.sold_date)" outlined dense hide-details />
              </v-col>
            </v-row>
            
            <v-divider class="mt-md-1"/>

            <v-row>
              <v-col>
                <v-text-field v-model="form_data.ont_reference" label="ONT Reference (FTTP)" outlined dense hide-details></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field v-model="form_data.ont_serial_number" label="ONT Serial Number (FTTP)" outlined dense hide-details></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field v-model="form_data.access_casr" label="Access CASR" outlined dense hide-details></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div class="edit-line__column">         
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field v-model="form_data.post_code_search" label="Postcode" hide-details outlined dense v-on:keyup.enter="doSearch" :disabled="manual_address">
                    <v-icon slot="append" color="secondary" v-if="form_data.post_code_search!==''" @click="doSearch">search</v-icon>
                </v-text-field>
              </v-col>
              
              <v-col cols="12" md="4">
                <v-switch hide-details label="Enter Manually" class="mt-0 pt-0 edit-line__manual" v-model="manual_address" />
              </v-col>
            </v-row>

            <template v-if="(get_addressSearch.length!==0||getIsAddressSearchLoading) && !manual_address">
              <v-row>
                <v-col>
                  <v-select :label="getIsAddressSearchLoading?'Loading...':'Select address'" v-model="chosenAddress" :loading="getIsAddressSearchLoading" :disabled="getIsAddressSearchLoading" :items="get_addressSearch" outlined dense return-object item-text="select_option">
                    <template slot="item" slot-scope="data">
                      <v-icon small :class="`mr-2 ${data.item.category}`">{{addressIcon}}</v-icon> {{data.item.select_option}}
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </template>

            <template>
              <v-divider/>
              <v-row>
                <v-col>
                  <v-text-field v-model="form_data.address.line_one" label="Line one" hide-details outlined dense :disabled="!manual_address" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="form_data.address.city" label="City" hide-details outlined dense :disabled="!manual_address" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="form_data.address.county" label="County" hide-details outlined dense :disabled="!manual_address" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="form_data.address.post_code" label="Postcode" hide-details outlined dense :disabled="!manual_address" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="form_data.address.country" label="Country" hide-details outlined dense :disabled="!manual_address" />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field v-model="form_data.line_address_reference" label="Line address reference" hide-details outlined dense :disabled="!hasUserGotRoles(['telco-provisioning'])||!manual_address" />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field v-model="form_data.css_database_code" label="CSS Database Code" hide-details outlined dense :disabled="!hasUserGotRoles(['telco-provisioning'])||!manual_address" />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field v-model="form_data.access_line_id" label="Access Line ID" hide-details outlined dense disabled />
                </v-col>
              </v-row>
            </template>
          </div>
        </div>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="getIsTelcoProvisioningLoading" :loading="getIsTelcoProvisioningLoading">Save</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="getIsTelcoProvisioningLoading">Close</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters,mapActions,mapMutations } from 'vuex';
  import { mdiCheckboxBlankCircle  } from '@mdi/js';

  export default {
    
    props: ['dialogOpen'],

    data() {
      return {
        addressIcon: mdiCheckboxBlankCircle ,
        manual_address: false,
        chosenAddress: {},
        form_data: {
          line_number: '',
          post_code_search: '',
          address: {
            line_one: '',
            city: '',
            county: '',
            post_code: '',
            country: '',
          },
          line_address_reference: '',
          css_database_code: '',
          access_line_id: '',
          ont_reference: '',
          ont_serial_number: '',
          access_casr: '',
          line_address_category: '',
        },
      }
    },

    computed: {
      ...mapGetters("globals", ['hasUserGotRoles']),
      ...mapGetters('products',['getCurrentProduct']),
      ...mapGetters('productTelco',['getIsTelcoProvisioningLoading','getTelcoProvisioning','get_addressSearch','getIsAddressSearchLoading']),
    },

    watch: {
      dialogOpen(opened){
        if(opened){
          this.form_data.line_number = this.getTelcoProvisioning.line_number;
          this.form_data.post_code_search = this.getTelcoProvisioning.line_address.post_code;
          this.form_data.address = this.getTelcoProvisioning.line_address;
          this.form_data.css_database_code = this.getTelcoProvisioning.css_database_code;
          this.form_data.line_address_reference = this.getTelcoProvisioning.address_ref;
          this.form_data.access_line_id = this.getTelcoProvisioning.access_line_id;
          this.form_data.ont_reference = this.getTelcoProvisioning.ont_reference;
          this.form_data.ont_serial_number = this.getTelcoProvisioning.ont_serial_number;
          this.form_data.access_casr = this.getTelcoProvisioning.access_casr;
          this.form_data.line_address_category = this.getTelcoProvisioning.line_address_category;
        }
      },

      chosenAddress(value){
        if(value.line_one){
          const address = {
            line_one: value.line_one,
            city: value.city,
            county: value.county,
            post_code: value.post_code,
            country: value.country,
          };
          this.form_data.address = address;
  
          this.form_data.css_database_code = value.css_database_code || '';
          this.form_data.line_address_reference = value.reference || '';
          this.form_data.access_line_id = value.access_line_id || '';
          this.form_data.line_address_category = value.category || '';
        }
      },

      manual_address(){
        this.resetAddressForm();
      },
    },

    methods: {
      ...mapActions('productTelco',['fetchAddressSearch','updateTelcoProvisioning']),
      ...mapMutations('productTelco',['reset_addressSearch']),

      async doSearch(){
        await this.fetchAddressSearch(this.form_data.post_code_search);
      },

      async submit() {
        let postData = {
          line_number: this.form_data.line_number || '',
          address_ref: this.form_data.line_address_reference,
          line_address_category: this.form_data.line_address_category,
          line_address: {
              post_code: this.form_data.address.post_code,
              line_one: this.form_data.address.line_one,
              city: this.form_data.address.city,
              county: this.form_data.address.county || '',
              country: this.form_data.address.country,
          },
          css_database_code: this.form_data.css_database_code,
          access_line_id: this.form_data.access_line_id,
          ont_reference: this.form_data.ont_reference,
          ont_serial_number: this.form_data.ont_serial_number,
          access_casr: this.form_data.access_casr,
        }
        let success = await this.updateTelcoProvisioning({pid:this.getCurrentProduct.id,data:postData});
        if(success){ this.close(); }
      },

      resetAddressForm(){
        this.chosenAddress = {};
        this.form_data.address = {
          line_one: '',
          city: '',
          county: '',
          post_code: '',
          country: '',
        };
        this.form_data.line_address_reference = '';
        this.form_data.css_database_code = '';
        this.form_data.access_line_id = '';
        this.form_data.line_address_category = '';
        this.reset_addressSearch();
      },

      resetform_data(){
        this.chosenAddress = {};
        this.form_data = {
          line_number: '',
          post_code_search: '',
          address: {
            line_one: '',
            city: '',
            county: '',
            post_code: '',
            country: '',
          },
          line_address_reference: '',
          css_database_code: '',
          access_line_id: '',
          ont_reference: '',
          ont_serial_number: '',
          access_casr: '',
          line_address_category: '',
        };
        this.reset_addressSearch();
      },

      close() {
        this.manual_address = false;
        this.resetform_data();
        this.$emit('close-dialog');
      },

    },

  }
</script>

<style lang="scss" scoped>
  .BRONZE{ color: #CD7F32 !important; }
  .SILVER{ color: #C4C4C4 !important; }
  .GOLD{ color: #FFD700 !important; }

  .edit-line__column {
    flex-basis: 50%;
  }

  .edit-line__manual {
    ::v-deep {
      .v-input__slot {
        flex-flow: column-reverse wrap;
      }

      .v-label {
        font-size: 14px;
      }
    }
  }
</style>
